import "./index.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Problem } from "./components/Problem";
import { Solution } from "./components/Solution";
import { Benefits } from "./components/Benefits";
import { Process } from "./components/Process";
import { Testimonials } from "./components/Testimonials";
import { Bonus } from "./components/Bonus";
import { About } from "./components/About";
import { Guarantees } from "./components/Guarantees";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";

/**
 * Componente principal da landing page
 * Importa e renderiza todas as seções da página
 */
function App() {
  return (
    <div className="min-h-screen bg-white">
      {/* Cabeçalho fixo com navegação */}
      <Header />

      <main>
        {/* Seção Hero - Chamada principal */}
        <Hero />

        {/* Seção de Problema - Identificação da dor do cliente */}
        <Problem />

        {/* Seção de Solução - Apresentação do método */}
        <Solution />

        {/* Seção de Benefícios - Vantagens do serviço */}
        <Benefits />

        {/* Seção de Processo - Como funciona */}
        <Process />

        {/* Seção de Depoimentos - Prova social */}
        <Testimonials />

        {/* Seção de Bônus - Valor adicional */}
        <Bonus />

        {/* Seção Sobre - Apresentação do especialista */}
        <About />

        {/* Seção de Garantias - Segurança para o cliente */}
        <Guarantees />

        {/* Seção de FAQ - Perguntas frequentes */}
        <FAQ />

        {/* Chamada final para ação */}
        <FinalCTA />
      </main>

      {/* Rodapé */}
      <Footer />
    </div>
  );
}

export default App;
